<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.academic.operation.classOperation.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('school.academic.operation.classOperation.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-whitespace-no-wrap ts-justify-between">
          <ts-button color="info" outline @click="$router.push({ name: 'class-operation-create' })">{{ $t('add_new')
            }}</ts-button>
          <div class="d-flex">
            <div class="ts-mr-2">
              <a-radio-group button-style="solid" v-model="isHasEnrollment" @change="fetchData()">
                <a-radio-button>
                  {{ $t('school.academic.operation.classOperation.all') }}
                </a-radio-button>
                <a-radio-button :value="0">
                  {{ $t('school.academic.operation.classOperation.empty') }}
                </a-radio-button>
                <a-radio-button :value="1">
                  {{
                    $t('school.academic.operation.classOperation.enrollment')
                  }}
                </a-radio-button>
              </a-radio-group>
            </div>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 250px" class="inline-block" />
            <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="showFilter">
              <i class="fa fa-filter"></i>
            </ts-button>
            <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
              @close="() => (visible = false)" :zIndex="1020" width="300px">
              <ts-loading-banner :loading="waiting_fetch">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>{{
                        $t('school.academic.operation.classOperation.branch')
                        }}</label>
                      <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
                        :filterOption="filterOption" :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')"
                        @change="onBranchChange">
                      </a-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>{{
                        $t(
                          'school.academic.operation.classOperation.academicYear'
                        )
                      }}</label>
                      <a-select style="width: 257px" v-model="acYearIdFilter" :options="acYear" showSearch allowClear
                        mode="multiple" :filterOption="filterOption" :maxTagCount="1" :maxTagTextLength="17"
                        :placeholder="$t('all')">
                      </a-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>{{
                        $t(
                          'school.academic.operation.classOperation.mainProgram'
                        )
                      }}</label>
                      <a-select style="width: 257px" v-model="acpId" :options="mainProgram" showSearch mode="multiple" allowClear
                        :filterOption="filterOption" :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')"
                        @change="getSubProgram"
                      >
                      </a-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>{{
                        $t(
                          'school.academic.operation.classOperation.subProgram'
                        )
                      }}</label>
                      <a-select style="width: 257px" v-model="acpsId" :options="subProgram" showSearch mode="multiple" allowClear
                        :filterOption="filterOption" :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                      </a-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        {{
                          $t('school.academic.operation.classOperation.status')
                        }}
                      </label>
                      <a-select class="ts-w-full" v-model="status" mode="multiple" @change="fetchData()">
                        <a-select-option :value="1">{{
                          $t('classoperation.current')
                          }}</a-select-option>
                        <a-select-option :value="2">{{
                          $t('classoperation.history')
                          }}</a-select-option>
                        <a-select-option :value="3">{{
                          $t('classoperation.next')
                          }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <ts-button color="primary" class="ts-w-full" @click="fetchData">{{ $t('view') }}</ts-button>
                  </div>
                </div>
              </ts-loading-banner>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{
          field: 'sub_program.acps_name_foreign'
        }">
          <template v-slot="{ record }">
            <td>
              {{ record.branch ? record.branch.branch_name_en : '' }}
            </td>
            <td>{{ record.class_name }}</td>
            <td class="text-center">
              <span class="ts-bg-teal-100 ts-px-2 ts-rounded-md ts-text-teal-600">{{ record.students_count }}</span>
            </td>
            <td>{{ record.grade.grade_name_foreign }}</td>
            <td>{{ record.room ? record.room.room_name : '' }}</td>
            <td>{{ record.academic_term.term_name }}</td>
            <td>
              {{
                record.teacher
                  ? record.teacher.lname_foreign +
                  ' ' +
                  record.teacher.fname_foreign
                  : ''
              }}
            </td>
            <td>{{ record.class_desc }}</td>
            <td>{{ record.academic_year.ac_year }}</td>
            <td class="text-center">
              <span class="label label-green" v-if="record.ac_status_id == 1">current</span>
              <span class="label label-secondary" v-if="record.ac_status_id == 2">history</span>
              <span class="label label-info" v-if="record.ac_status_id == 3">next</span>
            </td>
            <td>{{ record.created_date }}</td>
            <td>{{ record.created_by.employee.name_en }}</td>
            <td>{{ record.modified_date }}</td>
            <td>
              {{
                record.modified_by ? record.modified_by.employee.name_en : ''
              }}
            </td>
            <td class="text-left ts-whitespace-no-wrap">
              <a href="#" class="mr-2 text-primary" v-tooltip="$t('school.academic.operation.classOperation.student')
                " @click.prevent="showStudentList(record)">
                <i class="fas fa-users"></i>
              </a>
              <a href="#" class="mr-2 text-primary" @click.prevent="edit(record)" v-tooltip="$t('edit')">
                <i class="fas fa-edit"></i>
              </a>
              <a href="#" class="text-info ts-mr-2" @click.prevent="copyClass(record)" :disabled="record._deleting"
                v-tooltip="$t('copy')">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-copy" v-else></i>
              </a>
              <a href="#" class="text-danger" @click.prevent="destroy(record)" :disabled="record._deleting"
                v-tooltip="$t('delete')">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
          <template v-slot:tfooter>
            <tfoot>
              <tr>
                <td colspan="2">
                  <strong>Rows : {{ resources.length }}</strong>
                </td>
                <td class="ts-text-center">
                  <b class="ts-bg-teal-100 ts-px-2 ts-rounded-md ts-text-teal-600">{{ countStudent }}</b>
                </td>
                <td colspan="10"></td>
              </tr>
            </tfoot>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <!-- view student list -->
      <a-modal v-model="show_student_list" centered @ok="() => (show_student_list = false)" :zIndex="1020"
        :cancelText="$t('cancel')" :okText="$t('ok')" :footer="null" width="50%">
        <template v-slot:title>
          <div class="ts-flex ts-justify-between ts-items-baseline">
            <div>
              <h2>
                {{ $t('school.academic.operation.classOperation.studentList') }}
              </h2>
            </div>
            <div class="ts-pr-4">
              <div class="ts-flex">
                <h4>{{ classInfo.class_name }} |</h4>
                <h4>{{ classInfo.teacher_name }} |</h4>
                <h4>{{ classInfo.study_time }}</h4>
              </div>
            </div>
          </div>
        </template>
        <student-list :student="student_lists" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce, sumBy } from 'lodash'
import { mapActions, mapState } from 'vuex'
import StudentList from './components/view-student-list'
export default {
  name: 'classOperation',
  components: {
    StudentList
  },
  data() {
    return {
      waiting_fetch: false,
      visible: false,
      loading: false,
      all_year: false,
      show_student_list: false,
      student_lists: [],
      classInfo: {},
      branchs: [],
      acYear: [],
      mainProgram: [],
      subProgram: []

    }
  },
  mounted() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    // this.getBranch()
  },
  computed: {
    ...mapState('classOperation', ['resources', 'pagination']),
    countStudent() {
      return sumBy(this.resources, o => parseInt(o.students_count))
    },
    search: {
      get() {
        return this.$store.state.classOperation.search
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_SEARCH', newValue)
        this.$store.commit('classOperation/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.classOperation.branch_id
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_BRANCH_ID', newValue)
      }
    },
    acYearIdFilter: {
      get() {
        return this.$store.state.classOperation.acYearFilter
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_ACYEAR_ID_FILTER', newValue)
      }
    },
    isHasEnrollment: {
      get() {
        return this.$store.state.classOperation.isHasEnrollment
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_HAS_ENROLMENT_FILTER', newValue)
      }
    },
    columns() {
      return [
        {
          name: this.$t('school.academic.operation.classOperation.branch')
        },
        {
          name: this.$t('school.academic.operation.classOperation.className')
        },
        {
          name: this.$t('school.academic.operation.classOperation.student'),
          style: 'text-align:center'
        },
        {
          name: this.$t('school.academic.operation.classOperation.grade')
        },
        {
          name: this.$t('school.academic.operation.classOperation.room')
        },
        {
          name: this.$t('school.academic.operation.classOperation.term')
        },
        {
          name: this.$t('school.academic.operation.classOperation.teacher')
        },
        {
          name: this.$t('school.academic.operation.classOperation.description')
        },
        {
          name: this.$t('school.academic.operation.classOperation.academicYear')
        },
        {
          name: this.$t('school.academic.operation.classOperation.status'),
          style: 'text-align:center'
        },
        {
          name: this.$t('school.academic.operation.classOperation.createdDate')
        },
        {
          name: this.$t('school.academic.operation.classOperation.createdBy')
        },
        {
          name: this.$t('school.academic.operation.classOperation.modifiedDate')
        },
        {
          name: this.$t('school.academic.operation.classOperation.modifiedBy')
        },
        {
          name: this.$t('school.academic.operation.classOperation.actions'),
          style: 'width:7%; text-align:left'
        }
      ]
    },
    status: {
      get() {
        return this.$store.state.classOperation.ac_status_id
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_STATUS_ID', newValue)
      }
    },
    acpId: {
      get() {
        return this.$store.state.classOperation.acp_id
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_MAIN_PROGRAM_ID', newValue)
      }
    },
    acpsId: {
      get() {
        return this.$store.state.classOperation.acps_id
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_SUB_PROGRAM_ID', newValue)
      }
    }
  },
  methods: {
    ...mapActions('classOperation', ['formViewModel']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'classOperation/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async getBranch() {
      if (this.branchs.length > 0) return
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit(record) {
      this.$store.commit('classOperation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'class-operation-edit',
        params: { id: record.class_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('classOperation/destroy', record.class_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    async copyClass(record) {
      this.$store.commit('classOperation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'class-operation-copy-class',
        params: { id: record.class_id }
      })
    },
    showStudentList(record) {
      this.show_student_list = true
      this.classInfo = {
        class_name: record.class_name,
        teacher_name: record.teacher ? record.teacher.full_name_en : '',
        study_time: record.academic_study_time.study_time
      }
      this.student_lists = record.students
    },
    async getAcademicYear() {
      this.acYear = [];
      const response = await this.formViewModel({
        fnName: 'acYear',
        branch_id: this.branch_id
      })
      this.acYear = response.acYear.map(el => ({
        value: el.ac_year_id,
        label: `${el.prefix}-${el.ac_year}`
      }))
    },
    async getAcademicYear() {
      this.acYear = [];
      const response = await this.formViewModel({
        fnName: 'acYear',
        branch_id: this.branch_id
      })
      this.acYear = response.acYear.map(el => ({
        value: el.ac_year_id,
        label: `${el.prefix}-${el.ac_year}`
      }))
    },    
    async getMainProgram() {
      this.mainProgram = [];
      const response = await this.formViewModel({
        fnName: 'mainProgram',
        branch_id: this.branch_id
      })
      this.mainProgram = response.mainProgram.map(el => ({
        value: el.acp_id,
        label: `${el.prefix}-${el.acp_name_foreign}`
      }))
    },    
    async getSubProgram() {
      this.waiting_fetch = true
      this.subProgram = [];
      this.acpsId = undefined
      const response = await this.formViewModel({
        fnName: 'subProgram',
        acp_id: this.acpId
      })
      this.subProgram = response.subProgram.map(el => ({
        value: el.acps_id,
        label: `${el.prefix}-${el.acps_name_foreign}`
      }))
      this.waiting_fetch = false
    },
    async onBranchChange() {
      this.waiting_fetch = true
      this.acYearIdFilter = []
      this.mainProgram = []
      this.subProgram = []
      this.acpId = undefined
      this.acpsId = undefined
      await Promise.all([
        this.getAcademicYear(),
        this.getMainProgram()
      ])
      this.waiting_fetch = false
    },
    async showFilter() {
      this.visible = true
      this.waiting_fetch = true
      await Promise.all([
        this.getBranch(),
        this.getAcademicYear(),
        this.getMainProgram()
      ])
      this.waiting_fetch = false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500)
  },
  onBeforeRouteLeave(to, from, next) {
    this.$store.commit('classOperation/RESET_STATE')
    next()
  }
}
</script>
